import * as React from 'react';
import { Modal, Input } from 'antd';
import Form, { FormItem } from '../../../../../components/Form';
import CountrySelect from '../../../../../components/Others/CountrySelect';

interface IInvoicingSettingsModalProps {
  order: GQL.IOrder;
  onSubmit: (data: any) => void;
  onClose: () => void;
}

interface IInvoicingSettingsModalState {
  data: {
    // invoiceStreet: string | null;
    // invoiceHouseNumber: string | null;
    invoiceAddressLine1: string | null;
    invoiceAddressLine2: string | null;
    invoiceZip: string | null;
    invoiceCity: string | null;
    invoiceCountyState: string | null;
    invoiceCountry: string | null;
  };
}

class InvoicingSettingsModal extends React.Component<IInvoicingSettingsModalProps, IInvoicingSettingsModalState> {

  private form;

  constructor(props: IInvoicingSettingsModalProps) {
    super(props);

    this.state = {
      data: {
        // invoiceStreet: props.order.invoiceStreet,
        // invoiceHouseNumber: props.order.invoiceHouseNumber,
        invoiceAddressLine1: props.order.invoiceAddressLine1,
        invoiceAddressLine2: props.order.invoiceAddressLine2,
        invoiceZip: props.order.invoiceZip,
        invoiceCity: props.order.invoiceCity,
        invoiceCountyState: props.order.invoiceCountyState,
        invoiceCountry: props.order.invoiceCountry,
      },
    };

    this.form = React.createRef;

    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  public render() {
    return (
      <div>
        <Modal
          title="Invoicing settings"
          visible={true}
          okText={'Save changes'}
          onOk={this.onSubmit}
          onCancel={this.props.onClose}
          destroyOnClose={true}
          maskClosable={false}
        >
          <Form
            ref={f => this.form = f}
            displayFooter={false}
            onSubmit={this.onSubmit}
            onCancel={this.props.onClose}
          >
            {/* <FormItem label={'Street'} required={true}>
              <Input
                name={'invoiceStreet'}
                placeholder="Enter street"
                value={this.state.data.invoiceStreet || ''}
                required={true}
                onChange={this.onChange}
              />
            </FormItem>
            <FormItem label={'House number'} required={true}>
              <Input
                name={'invoiceHouseNumber'}
                placeholder="Enter house number"
                value={this.state.data.invoiceHouseNumber || ''}
                required={true}
                onChange={this.onChange}
              />
            </FormItem> */}
            <FormItem label={'Street address'} required={true}>
              <Input
                name={'invoiceAddressLine1'}
                placeholder="Enter street address"
                value={this.state.data.invoiceAddressLine1 || ''}
                required={true}
                onChange={this.onChange}
              />
            </FormItem>
            <FormItem label={'Address line 2'}>
              <Input
                name={'invoiceAddressLine2'}
                placeholder="Enter address line 2"
                value={this.state.data.invoiceAddressLine2 || ''}
                onChange={this.onChange}
              />
            </FormItem>
            <FormItem label={'City'} required={true}>
              <Input
                name={'invoiceCity'}
                placeholder="Enter city"
                value={this.state.data.invoiceCity || ''}
                required={true}
                onChange={this.onChange}
              />
            </FormItem>
            <FormItem label={'Zip'} required={true}>
              <Input
                name={'invoiceZip'}
                placeholder="Enter Zip code"
                value={this.state.data.invoiceZip || ''}
                required={true}
                onChange={this.onChange}
              />
            </FormItem>
            <FormItem label={'County / State'}>
              <Input
                name={'invoiceCountyState'}
                placeholder="Enter county / state"
                value={this.state.data.invoiceCountyState || ''}
                onChange={this.onChange}
              />
            </FormItem>
            <FormItem label={'Country'} required={true}>
              <CountrySelect
                name={'invoiceCountry'}
                value={this.state.data.invoiceCountry || ''}
                onChange={(e: any, country: GQL.ICountry) => this.onChange(e, country.name)}
              />
            </FormItem>
          </Form>
        </Modal>
      </div>
    );
  }

  private onChange(e: any, val?: string) {
    const { name, value } = e.target;

    const inputValue = (val ? val : value);

    this.setState({
      data: { ...this.state.data, [name]: inputValue }
    });
  }

  private onSubmit() {
    if (this.form) {
      if (this.form.validate()) {
        this.props.onSubmit(this.state.data);
      }
    }
  }
}

export default InvoicingSettingsModal;


// WEBPACK FOOTER //
// ./src/scenes/OrderView/OrderView/InvoicingSettings/components/Modal.tsx